import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import UserBadge from 'src/components/ui/UserBadge';

const TopControls = (props) => {
	const {
		user,
		disabled,
		addLabel,
		clickHandler = () => {},
		StatusPlateRP,
	} = props;

	return (
		<Stack direction="row" spacing={4} justifyContent="space-between">
			<Stack direction="row" spacing={2}>
				{StatusPlateRP && <StatusPlateRP />}
				{user && (
					<Paper sx={{ display: 'flex', height: 60, p: 2 }}>
						<UserBadge {...user} />
					</Paper>
				)}
			</Stack>
			<Stack direction="row">
				{addLabel && (
					<Button
						disabled={disabled}
						variant="contained"
						size="large"
						onClick={clickHandler}
					>
						<Typography variant="overline">{addLabel}</Typography>
					</Button>
				)}
			</Stack>
		</Stack>
	);
};

TopControls.propTypes = {
	user: PropTypes.shape(UserBadge.propTypes),
	StatusPlateRP: PropTypes.elementType,
	addLabel: PropTypes.string,
	clickHandler: PropTypes.func,
	disabled: PropTypes.bool,
};

export default TopControls;
